import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const initialState = () => ({
      standaloneCartsCreated: 0,
      ordersCreated: 0,
      ordersPaid: 0,
      cartTotalSum: 0,
      salesTotalSum: 0,
});

export default function useHostDailyStandaloneCarts(date = new Date()) {
      const { activeShopId } = useSelector((state) => state.shops);

      const [standaloneCartsSummary, setStandaloneCartsSummary] = useState(initialState());

      useEffect(() => {
            if (!activeShopId) {
                  setStandaloneCartsSummary(initialState());
                  return;
            }

            const startTime = new Date(new Date(date).setHours(0, 0, 0, 0));
            const endTime = new Date(new Date(date).setHours(23, 59, 59, 999));

            const ref = firebase
                  .firestore()
                  .collection('shops')
                  .doc(activeShopId)
                  .collection('carts')
                  .where('createdAt', '>=', startTime)
                  .where('createdAt', '<=', endTime)
                  .where('cartType', '==', 'standaloneCart');

            const fetchStandaloneCartsCount = async () => {
                  try {
                        const snapshot = await ref.get();

                        let total = 0;
                        let ordersCount = 0;
                        let paidOrdersCount = 0;
                        let salesTotal = 0;

                        snapshot.forEach(doc => {
                              const cartTotal = parseFloat(doc.data().cartTotal) || 0;
                              const totalOrderAmount = parseFloat(doc.data().totalOrderAmount) || 0;

                              total += cartTotal;

                              if (cartTotal > 0) {
                                    ordersCount++;
                              }

                              if (totalOrderAmount > 0) {
                                    paidOrdersCount++;
                                    salesTotal += totalOrderAmount;
                              }
                        });

                        setStandaloneCartsSummary({
                              standaloneCartsCreated: snapshot.size,
                              ordersCreated: ordersCount,
                              ordersPaid: paidOrdersCount,
                              cartTotalSum: Number(total.toFixed(2)),
                              salesTotalSum: Number(salesTotal.toFixed(2)),
                        });
                  } catch (error) {
                        console.error("Error fetching standalone carts:", error);
                        setStandaloneCartsSummary(initialState());
                  }
            };

            fetchStandaloneCartsCount();
      }, [activeShopId, date]);

      return {
            standaloneCartsSummary,
      };
}
